import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import authHeader from "./auth-header";

export const fetchAllAgorders = (filters = {}) => {
  let queryArr = [];
  for (let key in filters) {
    if (filters[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
    }
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agorder${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneAgorder = (id, options = {}) => {
  const { show_items, isColumnOrder } = options;
  const queryParams = [];
  
  if (show_items) {
    queryParams.push('show_items=true');
  }
  
  if (isColumnOrder) {
    queryParams.push('isColumnOrder=true');
  }
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agorder/${id}${queryString}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createOrder = (orderData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agorder/create`, orderData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error creating order");
      throw err;
    });
};

export const updateAgorder = ({ id, data }) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/agorder/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteAgorder = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/agorder/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchLastOrderNumber = (ordertype = '') => {
  const queryParam = ordertype ? `?ordertype=${ordertype}` : '';
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agorder/last-order-number${queryParam}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const generateOrderHistoryReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agorder/history-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating order history report");
      throw err;
    });
};

export const generateOrderHistoryActualReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agorder/history-report-actual`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating order history actual report");
      throw err;
    });
};

export const generateOrderRegisterReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agorder/register-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating order register report");
      throw err;
    });
};

export const generatePendingOrdersReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agorder/pending-orders-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating pending orders report");
      throw err;
    });
};

export const fetchOrderPrintFormats = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/ordprintformat`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error fetching print formats");
      throw err;
    });
};

export const generateOrderPrint = (orderId, formatId = null, sizeGroupId = null, withRate = null) => {
  let url = `${process.env.REACT_APP_BASE_URL}/agorder/${orderId}/report`;
  
  // Add query parameters if provided
  const params = new URLSearchParams();
  if (formatId) params.append('formatId', formatId);
  if (sizeGroupId) params.append('sizeGroupId', sizeGroupId);
  if (withRate !== null) params.append('withRate', withRate);
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  return axios
    .get(url, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating order print");
      throw err;
    });
};
